// apps/web/src/pages/landing.tsx
// TOC landing page at `/` — replaces the prior <Navigate to="/brief"/>.
// Auth-gated via indexRoute.beforeLoad (routes.tsx). Option D #3 (2026-05-21).
//
// Static page (no data fetch) — 4 cards link to the protected dashboards.
// Sign-in success destination updated to '/' so users see the TOC every login.

import type { CSSProperties } from 'react';
import { Link } from '@tanstack/react-router';

import { PRODUCT_NAME, PRODUCT_VERSION } from '../lib/product.js';
import { DASHBOARDS } from '../lib/dashboards.js';

const MAIN: CSSProperties = {
  padding:   '4rem 2rem',
  maxWidth:  900,
  margin:    '0 auto',
};
const TITLE: CSSProperties = {
  fontSize:      14,
  letterSpacing: '0.08em',
  textTransform: 'uppercase',
  color:         'var(--color-text-4)',
  marginBottom:  24,
};
const GRID: CSSProperties = {
  display:             'grid',
  gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
  gap:                 16,
};
const CARD: CSSProperties = {
  background:     'var(--color-bg-2)',
  border:         '1px solid var(--color-border)',
  borderRadius:   4,
  padding:        20,
  display:        'grid',
  gap:            8,
  color:          'var(--color-text-2)',
  textDecoration: 'none',
};
const CARD_HEAD: CSSProperties = { display: 'flex', alignItems: 'center', gap: 10 };
const ICON: CSSProperties = { fontSize: 20, color: 'var(--color-accent)' };
const LABEL: CSSProperties = {
  fontSize:      13,
  fontWeight:    600,
  letterSpacing: '0.04em',
  color:         'var(--color-text-1)',
};
const DESC: CSSProperties = { fontSize: 13, color: 'var(--color-text-3)', lineHeight: 1.5 };
const FOOTER: CSSProperties = {
  marginTop:  48,
  textAlign:  'center',
  color:      'var(--color-text-4)',
  fontSize:   11,
};

export function Landing(): JSX.Element {
  return (
    <main style={MAIN}>
      <div style={TITLE}>cf-apps · {PRODUCT_NAME.toLowerCase()} {PRODUCT_VERSION}</div>
      <div style={GRID}>
        {DASHBOARDS.map((d) => (
          <Link key={d.id} to={d.to} style={CARD}>
            <div style={CARD_HEAD}>
              <span style={ICON}>{d.icon}</span>
              <span style={LABEL}>{d.label}</span>
            </div>
            <span style={DESC}>{d.description}</span>
          </Link>
        ))}
      </div>
      <div style={FOOTER}>Cloudflare · not advice</div>
    </main>
  );
}
